export const pflDomains = [
  "poonawallafincorp-platform.finbox.in",
  "localhost:3000",
  "platformuat.finbox.in"
];

export const hfclDomains = [
  "herofincorp-lenders.finbox.in",
  "herofincorp-platform.finbox.in",
  "finbox-lender-dashboard-uat-19.s3-website.ap-south-1.amazonaws.com",
  "herofincorp-lender.fbxcloud.in",
  "finbox-platform-dashboard-uat-19.s3-website.ap-south-1.amazonaws.com",
  "herofincorp-platform.fbxcloud.in",
  "localhost:3001",
  "localhost:3000"
];

const host = window?.location?.host || "";
const appID = host.includes("platform")
  ? "platform_dashboard"
  : "lending_dashboard";

export const hfclStyling = {
  theme: {
    color: {
      bg: "!bg-[#174035]",
      darkbg: "!bg-[#174035]",
      text: "!text-[#174035]",
      lightbg: "!bg-[#EDFFE8]",
      border: "!border-[#174035]",
      borderDark: "!border-[#174035]"
    },
    hover: {
      bg: "hover:!bg-[#EDFFE8]",
      text: "hover:!text-[#174035]",
      darkbg1: "hover:!bg-[#174035]",
      // focus:ring-indigo-500 focus:border-indigo-500
      focus: "focus:!border-[#174035]",
      ring: "focus:!ring-[#174035]"
    },
    after: {
      color1: "after:bg-[#174035]"
    }
  },
  navbar: {
    logo: {
      img: "https://cdn-ind-01.finbox.in/finbox-logos/hero-logo-light.png",
      className: "md:w-[152px] md:h-auto w-10 h-10"
    },
    poweredBy: true
  },
  login: {
    hideFinbox: true,
    text: {
      title: "Sign in",
      subtitle: `Sign in to access your ${appID === "platform_dashboard" ? "Platform" : "Lender"} Dashboard`
    }
  },
  forgetPassword: {
    hideFinbox: true,
    text: {
      title: "Forgot Password",
      subtitle:
        "Please enter the email address to which the password reset link has to be sent"
    }
  },
  resetPassword: {
    text: {
      title: "Reset Password",
      subtitle: "Reset Password to access your Platform Dashboard"
    }
  },
  input: {
    class: "focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
  }
};

export const pflStyling = {
  theme: {
    color: {
      bg: "!bg-[#243970]",
      darkbg: "!bg-[#243970]",
      text: "!text-[#243970]",
      lightbg: "!bg-[#c4cce2]",
      border: "!border-[#243970]",
      borderDark: "!border-[#243970]"
    },
    hover: {
      bg: "hover:!bg-[#c4cce2]",
      text: "hover:!text-[#243970]",
      darkbg1: "hover:!bg-[#243970]",
      // focus:ring-indigo-500 focus:border-indigo-500
      focus: "focus:!border-[#243970]",
      ring: "focus:!ring-[#243970]"
    },
    after: {
      color1: "after:bg-[#243970]"
    }
  },
  navbar: {
    logo: {
      img: "https://cdn-ind-01.finbox.in/assets/PFL.svg",
      className: "md:w-[152px] md:h-auto w-10 h-10"
    },
    poweredBy: true
  },
  login: {
    hideFinbox: true,
    text: {
      title: "Sign in",
      subtitle: "Sign in to access your Platform Dashboard"
    }
  },
  forgetPassword: {
    hideFinbox: true,
    text: {
      title: "Forgot Password",
      subtitle:
        "Please enter the email address to which the password reset link has to be sent"
    }
  },
  resetPassword: {
    text: {
      title: "Reset Password",
      subtitle: "Reset Password to access your Platform Dashboard"
    }
  },
  input: {
    class: "focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
  }
};
